export default __webpack_public_path__ + "static/media/icon-essen.3924160a.svg";